export interface BalanceFilterOption {
    id: number;
    caption: string;
    longCaption: string;
    active: boolean;
    type: BalanceFilterType;
}

export enum BalanceFilterType {
    HourBalance = 0,
    DeploymentCount = 1,
    LeaveOverview = 2,
}

export interface BalanceFilterEnabled {
    id: number;
    type: BalanceFilterType;
    enabled: boolean;
}

export interface DeploymentCountStartDate {
    days: null;
    date: Date;
}

export interface DeploymentCountStartDaysAgo {
    days: number;
    date: null;
}

export type DeploymentCounterStart = DeploymentCountStartDaysAgo | DeploymentCountStartDate;
